import { UPDATE_FORM } from '../actions/form';
import { createReducer } from 'redux-create-reducer';

const dirtyReducer = createReducer(false, {
  [UPDATE_FORM]: (state, action) => true,
});

export default dirtyReducer;

export const getIsDirty = state => state.dirty;



// WEBPACK FOOTER //
// ./src/modules/saas/pco/cases-creation/step4/reducers/dirty.js